import React from 'react'

import { InfoWindow, Marker } from '@react-google-maps/api'
import PropTypes from 'prop-types'

import map from 'lodash/map'

import { getPolygonCenter } from '@galo-monitor/utils/maps'
import Polygon from '@galo-monitor/web-components/Maps/Google/components/Polygon'

import { DEFAULT_ZOOM } from '../../GoogleMaps'

const PopupPolygon = React.forwardRef(({ children, paths, markerIconSvg, currentMapZoom, ...props }, polygonRef) => {
  const [openInfo, setOpenInfo] = React.useState(false)

  const polygonCenter = React.useMemo(
    () => getPolygonCenter(
      map(paths, path => ({ latitude: path.lat, longitude: path.lng }))
    ),
    [paths]
  )

  const toggleInfoWindow = React.useCallback(
    () => setOpenInfo(prevState => !prevState),
    []
  )

  return (
    <>
      <Polygon
        ref={ polygonRef }
        paths={ paths }
        onClick={ toggleInfoWindow }
        { ...props }
      />
      {markerIconSvg ? (
        <Marker
          position={ polygonCenter }
          icon={ {
            url: markerIconSvg,
            scaledSize: {
              height: 1.5 * currentMapZoom,
              width: 1.5 * currentMapZoom
            }
          } }
        />
      ) : null}
      {openInfo ? (
        <InfoWindow
          position={ polygonCenter }
          onCloseClick={ toggleInfoWindow }
        >
          {children}
        </InfoWindow>
      ) : null}
    </>
  )
})

PopupPolygon.propTypes = {
  children: PropTypes.element.isRequired,
  markerIconSvg: PropTypes.string,
  paths: PropTypes.arrayOf(PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number
  })).isRequired,
  clusterer: PropTypes.object,
  currentMapZoom: PropTypes.number
}

PopupPolygon.defaultProps = {
  clusterer: {},
  markerIconSvg: '',
  currentMapZoom: DEFAULT_ZOOM
}

export default PopupPolygon
